/**
 * Nancy Finds — Custom Analytics & Events
 * Fires Meta Pixel custom events based on product state.
 * Tracks: PreOrderInitiated, WaitlistSignup (handled in waitlist-form.liquid),
 *         OutletViewContent (enhanced ViewContent with state)
 */

(function() {
  'use strict';

  var OutletAnalytics = {
    init: function() {
      this.trackEnhancedView();
      this.interceptPreOrderATC();
    },

    /**
     * Enhanced ViewContent — adds outlet_state to the standard ViewContent event
     */
    trackEnhancedView: function() {
      var productJson = document.getElementById('product-json');
      if (!productJson) return;

      try {
        var product = JSON.parse(productJson.textContent);
        var state = this.getProductState(product);

        if (typeof fbq !== 'undefined' && state !== 'unknown') {
          fbq('trackCustom', 'OutletViewContent', {
            content_name: product.title,
            content_ids: [String(product.id)],
            content_type: 'product',
            outlet_state: state,
            value: (product.price / 100).toFixed(2),
            currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
          });
        }
      } catch (e) {
        // Silently fail — analytics should never break the page
      }
    },

    /**
     * Intercept pre-order Add to Cart clicks to fire PreOrderInitiated event
     */
    interceptPreOrderATC: function() {
      var preorderBtn = document.querySelector('[data-outlet-state="preorder"]');
      if (!preorderBtn) return;

      preorderBtn.addEventListener('click', function() {
        var productId = this.dataset.productId;
        var productTitle = this.dataset.productTitle;

        if (typeof fbq !== 'undefined') {
          fbq('trackCustom', 'PreOrderInitiated', {
            content_name: productTitle,
            content_ids: [productId],
            content_type: 'product'
          });
        }
      });
    },

    /**
     * Determine product state from tags embedded in product JSON
     */
    getProductState: function(product) {
      if (!product.tags) return 'unknown';
      var tags = Array.isArray(product.tags) ? product.tags : product.tags.split(', ');
      if (tags.indexOf('outlet-selling') !== -1) return 'selling';
      if (tags.indexOf('outlet-preorder') !== -1) return 'preorder';
      if (tags.indexOf('outlet-waitlist') !== -1) return 'waitlist';
      return 'unavailable';
    }
  };

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { OutletAnalytics.init(); });
  } else {
    OutletAnalytics.init();
  }
})();

// ── PDP description read-more (mobile only) ──────────────────────────────────
(function() {
  function initReadMore() {
    var btn = document.querySelector('.pdp-read-more');
    var desc = document.querySelector('.pdp-desc-wrap');
    if (!btn || !desc) return;

    // Only activate on mobile viewports
    if (window.innerWidth > 768) {
      btn.style.display = 'none';
      return;
    }

    btn.addEventListener('click', function() {
      var expanded = desc.classList.toggle('is-expanded');
      btn.classList.toggle('is-expanded', expanded);
      btn.textContent = expanded ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', expanded);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReadMore);
  } else {
    initReadMore();
  }
})();
